// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="custom.d.ts" />

import kaiBubble from './kai-bubble.svg';
import bankLogin from './kai-bubble.svg';
import bankIdLogo from './BankIdLogo.svg';
import minIdLogo from './MinIdLogo.svg';
import bankIdMobile from './BankIdMobile.svg';
import bubbleMyScore1 from './bubble-my-score-1.svg';
import bubbleMyScore2 from './bubble-my-score-2.svg';
import bubbleMyScore3 from './bubble-my-score-3.svg';
import bubbleOmOssLast from './bubble-om-oss-last.svg';
import bubbleOmOssTop from './bubble-om-oss-top.svg';
import bubbleOmOssTopDesktop from './bubble-om-oss-top-desktop.svg';
import bubbleHomepage1 from './bubble-homepage-1.svg';
import bubbleHomepage2 from './bubble-homepage-2.svg';
import bubbleHomepage3 from './bubble-homepage-3.svg';
import teamBubble01 from './team01-bubble.svg';
import teamBubble02 from './team02-bubble.svg';
import teamBubble03 from './team03-bubble.svg';
import teamBubble04 from './team04-bubble.svg';
import bubbleTop from './bubble-top.svg';
import linkedinIcon from './linkedin-icon.svg';
import facebookIcon from './facebook-icon.svg';
import upscoreArrow from './upscore-arrow.svg';
import gIcon from './g-icon.svg';
import swipeIcon from './swipe-icon.svg';
import sliderArrow from './slider-arrow.svg';
import facebook from './facebook.svg';
import twitter from './twitter.svg';
import bubbleRed from '/bubble-red.svg';

export const icons = {
    kaiBubble,
    bankIdLogo,
    minIdLogo,
    bankIdMobile,
    bubbleMyScore1,
    bubbleMyScore2,
    bubbleMyScore3,
    bubbleOmOssLast,
    bubbleOmOssTop,
    bubbleOmOssTopDesktop,
    bubbleHomepage1,
    bubbleHomepage2,
    bubbleHomepage3,
    teamBubble01,
    teamBubble02,
    teamBubble03,
    teamBubble04,
    bubbleTop,
    linkedinIcon,
    facebookIcon,
    bankLogin,
    upscoreArrow,
    gIcon,
    swipeIcon,
    sliderArrow,
    facebook,
    twitter,
} as any;
